import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Table, TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { DatePickerModule } from 'primeng/datepicker';
import { FluidModule } from 'primeng/fluid';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ClientPackageMappingViewModel } from '../viewmodels/client-package-mapping-viewmodel';
import { ToastService } from '../../../toast/toast.service';
import { ConfirmationService } from 'primeng/api';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-client-package-mapping',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ButtonModule,
    DialogModule,
    SelectModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    DatePickerModule,
    FluidModule,
    TooltipModule,
    ConfirmDialogModule
  ],
  providers: [ConfirmationService],
  templateUrl: './client-package-mapping.component.html',
  styleUrls: ['./client-package-mapping.component.scss']
})
export class ClientPackageMappingComponent implements OnInit {
  private http = inject(HttpClient);
  private messageService = inject(ToastService);
  private confirmationService = inject(ConfirmationService);
  private fb = inject(FormBuilder);
  
  viewModel = new ClientPackageMappingViewModel(this.http, this.messageService, this.confirmationService, this.fb);
  
  @ViewChild('dt') table!: Table;
  
  ngOnInit(): void {
    this.viewModel.init();
  }
}
